type BlockedPosition = { name?: string | null; alias?: string | null };

/** Each blocked position with a key unique in the list: two that share a name and alias are told apart by a count. */
export function keyedBlockedPositions<T extends BlockedPosition>(positions: T[]): Array<{ key: string; position: T }> {
	const seen = new Map<string, number>();
	return positions.map((position) => {
		const base = `${position.name}|${position.alias}`;
		const count = (seen.get(base) ?? 0) + 1;
		seen.set(base, count);
		return { key: `${base}#${count}`, position };
	});
}
